import { AavoButton, AavoButtonProps } from "src/components/common/buttons/AavoButton.tsx";
import { useOpenLegacyView } from "src/components/views/legacy/hooks.ts";
import i18n from "i18next";
import { openLegacyCustomerOrderView } from "src/components/views/legacy/legacyViewAdapters.ts";
import { faFileInvoiceDollar } from "@fortawesome/pro-regular-svg-icons";
import { useTenantCustomizations } from "src/tenantCustomizations/useTenantCustomizations.tsx";
import { ValueOrProvider, resolveValueOrProvider } from "src/utils/valueOrProvider.ts";

export interface OpenCustomerOrderButtonProps extends Omit<AavoButtonProps, "onClick"> {
	customerOrderId: ValueOrProvider<number>;
}

export const OpenCustomerOrderButton = ({
	customerOrderId: customerOrderIdOrProvider,
}: OpenCustomerOrderButtonProps) => {
	const openLegacyView = useOpenLegacyView();

	const { tenantConfig } = useTenantCustomizations();
	if (!tenantConfig.erp.salesEnabled) return null;

	return (
		<AavoButton
			label={i18n.t("open_customer_order")}
			icon={faFileInvoiceDollar}
			variant={"outlined"}
			onClick={() => {
				const customerOrderId = resolveValueOrProvider(customerOrderIdOrProvider);
				openLegacyCustomerOrderView(openLegacyView, customerOrderId);
			}}
		/>
	);
};
